import React from 'react';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import GetAppIcon from '@mui/icons-material/GetApp';
import IconButton from '@mui/material/IconButton';

import "@progress/kendo-theme-default/dist/all.css";

import { LoadButtonHeaderTable } from '../../../components/sharedViews/loadActionsHeader/LoadButtonHeaderTable';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import ComplexColumnChart from '../components/charts/ComplexColumnChart';
import StackedColumnChart from '../components/charts/StackedColumnChart';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import SimpleColumnChart from '../components/charts/SimpleColumnChart';
import FunnelChart from '../components/charts/FunnelChart';
import GridPivot from '../components/gridPivot/GridPivot';
import AreaChart from '../components/charts/AreaChart';
import LineChart from '../components/charts/LineChart';
import PieChart from '../components/charts/PieChart';
import StatCard from '../components/card/StatCard';
import DoughnutChart from '../components/charts/DoughnutChart';
import BarGroupChart from '../components/charts/BarGroupChart';
import BarChart from '../components/charts/BarChart';
import SimpleLineChart from '../components/charts/SimpleLineChart';
import useManageCharts from '../hooks/useManageCharts';
import SimpleBarChart from '../components/charts/SimpleBarChart';

export const LayoutCharts = ({ conf = null }) => {
    const {
        infoAction,
        configuration,
        filters,
        companies,
        loading,
        openDialogCompany,
        handleConfirmAction,
        Cancel,
        setfil,
        getChartRef,
        handleExport,
        exportToExcel
    } = useManageCharts(conf);

    return (

        <Box sx={{ width: '100%' }} className='custom-hard-table-zd-nix'>
            <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
                >
                    <Box>
                        <Typography sx={{
                            color: (theme) => theme.palette.text.primary,
                            fontWeight: 'bold',
                            fontSize: "20px"
                        }}>
                            {infoAction?.name || 'Reportes'}
                        </Typography>
                        {infoAction?.description &&
                            < Typography sx={{
                                color: (theme) => theme.palette.text.primary,
                                fontSize: "14px"
                            }}>
                                {infoAction.description}
                            </Typography>
                        }
                    </Box>
                    <Grid>
                        <LoadButtonHeaderTable
                            buttons={configuration.buttons}
                            id_user_action={''}
                            DocManager={null}
                            columns={[]}
                            handleChange={setfil}
                            appliedFilters={filters}
                        />
                    </Grid>
                </Box>
            </Box>

            <div
                className="grid-responsivo"
            >
                {!loading && (
                    configuration.charts.map((item, idx) => {
                        const currentRef = getChartRef(idx);
                        return (
                            <Box
                                key={idx}
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    background: "#fff",
                                    ...item.chart?.size || item.config?.size || {}
                                }}
                            >
                                {item?.download &&
                                    <IconButton
                                        size="small"
                                        title="Exportar a Excel"
                                        sx={{
                                            position: "absolute",
                                            top: 8,
                                            right: 8,
                                            zIndex: 1000,
                                            backgroundColor: "rgba(255,255,255,0.95)",
                                            boxShadow: 2,
                                            "&:hover": { backgroundColor: "#f0f0f0" }
                                        }}
                                        onClick={() => handleExport(idx)}
                                    >
                                        <GetAppIcon color="success" fontSize="small" />
                                    </IconButton>
                                }
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        overflow: item.type === 'gridPivot' ? "auto" : "hidden",
                                        minWidth: item.type === 'gridPivot' ? 0 : undefined,
                                        minHeight: item.type === 'gridPivot' ? 0 : undefined
                                    }}
                                >
                                    {item.type === 'area' && <AreaChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'complexColumn' && <ComplexColumnChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'simpleColumn' && <SimpleColumnChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'line' && <LineChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'pie' && <PieChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'funnel' && <FunnelChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'stackedColumn' && <StackedColumnChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'gridPivot' && <GridPivot data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'card' && <StatCard data={item} filters={filters} />}
                                    {item.type === 'doughnut' && <DoughnutChart data={item} filters={filters} />}
                                    {item.type === 'groupBars' && <BarGroupChart data={item} filters={filters} />}
                                    {item.type === 'simpleBars' && <BarChart data={item} filters={filters} />}
                                    {item.type === 'simpleLine' && <SimpleLineChart data={item} filters={filters} />}
                                    {item.type === 'simpleColumnHzn' && <SimpleBarChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                </Box>
                            </Box>
                        );
                    })
                )}
            </div>

            <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            />
            {loading && <LoadingOverlay isOpen={loading} />}
        </Box>
    );
}